import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

export class Home extends Component {
  static displayName = Home.name;

  render () {
      return (<Navigate to="/myphoenix" />);
  }
}
